import React from 'react';
import { Check } from 'lucide-react';
export function PWASection() {
  return <section className="w-full py-20 md:py-24 relative font-heading overflow-hidden" style={{
    backgroundColor: '#09090B'
  }} data-id="element-668">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-669">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-670">
          {/* Left: Content */}
          <div data-id="element-671">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-672">
              Pas d'app store.
              <br data-id="element-673" />
              Pas de contrainte IT.
            </h2>
            <p className="text-xl text-white/60 mb-10" data-id="element-674">
              MeetOS s'installe directement depuis le navigateur sur iOS et
              Android.
            </p>

            <ul className="space-y-6" data-id="element-675">
              {['Fonctionne hors ligne — agenda, profils, carte du lieu mis en cache localement', 'Notifications push — comportement identique à une app native', "Aucun déploiement MDM, aucune restriction appareil d'entreprise", 'Mises à jour instantanées pour tous les utilisateurs — zéro fragmentation de version', "Accessible sur n'importe quel smartphone, tablette ou ordinateur"].map((point, index) => <li key={index} className="flex items-start gap-4" data-id="element-676">
                  <div className="mt-1 w-6 h-6 rounded-full bg-cyan-500/20 flex items-center justify-center flex-shrink-0" data-id="element-677">
                    <Check className="w-3.5 h-3.5 text-cyan-400" data-id="element-678" />
                  </div>
                  <span className="text-white/80 leading-relaxed" data-id="element-679">{point}</span>
                </li>)}
            </ul>
          </div>

          {/* Right: Abstract Phone Mockup */}
          <div className="relative flex justify-center lg:justify-end" data-id="element-680">
            {/* Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[500px] bg-cyan-500/10 rounded-full blur-[80px]" data-id="element-681" />

            {/* Phone Frame */}
            <div className="relative w-[300px] h-[600px] bg-white/[0.02] border border-white/[0.08] rounded-[40px] p-4 shadow-2xl backdrop-blur-sm" data-id="element-682">
              {/* Screen */}
              <div className="w-full h-full bg-[#09090B] rounded-[28px] border border-white/[0.04] overflow-hidden relative flex flex-col" data-id="element-683">
                {/* Status Bar Area */}
                <div className="h-12 w-full flex justify-center items-start pt-3" data-id="element-684">
                  <div className="w-24 h-6 bg-white/[0.05] rounded-full" data-id="element-685" />
                </div>

                {/* Abstract UI Elements */}
                <div className="flex-1 p-5 space-y-6" data-id="element-686">
                  {/* Header */}
                  <div className="flex items-center justify-between" data-id="element-687">
                    <div className="w-10 h-10 rounded-full bg-white/[0.05]" data-id="element-688" />
                    <div className="w-8 h-8 rounded-full bg-cyan-500/20" data-id="element-689" />
                  </div>

                  {/* Hero Card */}
                  <div className="w-full h-40 rounded-2xl bg-gradient-to-br from-cyan-500/10 to-blue-500/10 border border-white/[0.05] p-4 flex flex-col justify-end" data-id="element-690">
                    <div className="w-2/3 h-4 bg-white/[0.1] rounded mb-2" data-id="element-691" />
                    <div className="w-1/2 h-3 bg-white/[0.05] rounded" data-id="element-692" />
                  </div>

                  {/* List Items */}
                  <div className="space-y-3" data-id="element-693">
                    {[1, 2, 3].map(i => <div key={i} className="w-full h-16 rounded-xl bg-white/[0.03] border border-white/[0.05] p-3 flex items-center gap-3" data-id="element-694">
                        <div className="w-10 h-10 rounded-lg bg-white/[0.05]" data-id="element-695" />
                        <div className="flex-1 space-y-2" data-id="element-696">
                          <div className="w-3/4 h-2.5 bg-white/[0.08] rounded" data-id="element-697" />
                          <div className="w-1/2 h-2 bg-white/[0.04] rounded" data-id="element-698" />
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Bottom Nav */}
                <div className="h-20 w-full border-t border-white/[0.05] bg-white/[0.02] flex items-center justify-around px-6 pb-4" data-id="element-699">
                  <div className="w-6 h-6 rounded bg-cyan-500/40" data-id="element-700" />
                  <div className="w-6 h-6 rounded bg-white/[0.1]" data-id="element-701" />
                  <div className="w-6 h-6 rounded bg-white/[0.1]" data-id="element-702" />
                  <div className="w-6 h-6 rounded bg-white/[0.1]" data-id="element-703" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}